import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box, Stack } from '@mui/material';

import { getAvailabilityStatusesAction } from '../../../services/request';
import { AvailabilityStatusList } from './availability-status/AvailabilityStatusList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';
import { AvailabilityStatusSidebar } from './availability-status/AvailabilityStatusSidebar';
import Scrollbar from '../../../components/Scrollbar';

export const AvailabilityStatusRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getAvailabilityStatusesAction(search, 'GET'));
  const optionsRequest = useQuery(getAvailabilityStatusesAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [availabilityStatuses, setAvailabilityStatuses] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allSeasons, setAllSeasons] = React.useState([]);
  const [createSignal, setCreateSignal] = React.useState(false);
  const [allPeriods, setAllPeriods] = React.useState([]);
  const [allPackages, setAllPackages] = React.useState([]);
  const [allStatusChoices, setAllStatusChoices] = React.useState([]);
  const [allAvailabilityLevels, setAllAvailabilityLevels] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setAvailabilityStatuses(payload.results);
    }
  }, [loading, search]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      const getActions = optionsRequest.payload?.actions?.GET || {};
      setAllSeasons(getActions.season?.choices || []);
      setAllPeriods(getActions.period?.choices || []);
      setAllPackages(getActions.package?.choices || []);
      setAllStatusChoices(getActions.status?.choices || []);
      setAllAvailabilityLevels(getActions.availability_level?.choices || []);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setAvailabilityStatuses(
        _.map(availabilityStatuses, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setAvailabilityStatuses(_.filter(availabilityStatuses, obj => obj.id !== obj2.id));
    } else {
      setAvailabilityStatuses([obj2, ...availabilityStatuses]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Stack direction="row" sx={{ height: 'calc(100% + 64px)' }}>
        { !hideSidebar && (
          <AvailabilityStatusSidebar
            isOpenSidebar={openSidebar}
            onCloseSidebar={() => setOpenSidebar(false)}
            createSignal={() => setCreateSignal(true)}
            queryCallback={queryCallback}
          />
        )

        }
        <AvailabilityStatusList
          sx={{ flex: '1 1 90%' }}
          loading={loading}
          hideSidebar={() => setHideSidebar(!hideSidebar)}
          onOpenSidebar={() => setOpenSidebar(true)}
          availabilityStatuses={availabilityStatuses}
          queryCallback={queryCallback}
          submitCallback={submitCallback}
          allSeasons={allSeasons}
          createSignal={createSignal}
          turnOffCreateSignal={() => setCreateSignal(false)}
          allPeriods={allPeriods}
          allPackages={allPackages}
          allStatusChoices={allStatusChoices}
          allAvailabilityLevels={allAvailabilityLevels} />
      </Stack>
    </>
  );
};
